import Filter from 'components/Filter/Filter';

export default Filter;
